import React from 'react';
import { Typography, Tooltip } from '@material-ui/core';

import eliteBronze from '../../assets/eliteBronze.svg';
import eliteSilver from '../../assets/eliteSilver.svg';
import eliteGold from '../../assets/eliteGold.svg';
import elitePlatinum from '../../assets/elitePlatinum.svg';
import theWheel from '../../assets/theWheel.svg';
import theWheel2 from '../../assets/theWheel2.svg';

//Helper functions for the pages that show Umpire Statistics

export const getEliteStatus = (gameTotal) => {
    let icon = '';
    let title = '';
    if (gameTotal >= 50) {
      icon = elitePlatinum;
      title = 'Platinum Elite';
    }
    else if (gameTotal >= 32) {
      icon = eliteGold;
      title = 'Gold Elite';
    } else if (gameTotal >= 24) {
      icon = eliteSilver;
      title = 'Silver Elite';
    } else if (gameTotal >= 16) {
      icon = eliteBronze;
      title = 'Bronze Elite';
    };

    return ({icon, title});
};

export const renderWheelInfo = (umpireStats) => {

  if (umpireStats.hasWheel2)
    return (
      <Typography align="center" variant="h4" component="h2">
        <Tooltip title="The Wheel 2"><img src={theWheel2} alt="The Wheel 2" height={32}/></Tooltip>
      </Typography>);
  else if (umpireStats.hasWheel) 
    return (
      <Typography align="center" variant="h4" component="h2">
        <Tooltip title="The Wheel"><img src={theWheel} alt="The Wheel" height={32}/></Tooltip>
      </Typography>);
  else {
    let numDivisions = 0, umpDivisions = 0, missingDivisions = 'Needed:';
    for (const divisionId in umpireStats.divisionCounts) {
      if (umpireStats.divisionCounts.hasOwnProperty(divisionId)) {
        numDivisions++;
        const division = umpireStats.divisionCounts[divisionId];
        if (division.plate + division.base > 0) umpDivisions++;
        else missingDivisions += (missingDivisions && ' ') + division.name;
      }
    }
    return (
      <Tooltip title={missingDivisions}>
        <Typography align="center" variant="h4" component="h2">
          {umpDivisions}/{numDivisions}
        </Typography>
      </Tooltip>);
  }
};

export const renderTeams = (teamsList) => {
  let teams = '';

  teamsList.forEach( (team, index) => {
    if (index !== 0) teams += '\n';
    teams += `${team.teamName} (${team.shortDivisionName})`;
  });

  return (
    <Tooltip title={teams}>
      <Typography align="center" variant="h4" component="h2">{teamsList.length}</Typography>
    </Tooltip>
  );
}


// WEBPACK FOOTER //
// ./src/components/statistics/gameStatistics.js